import React from 'react'
import PropTypes from 'prop-types'

import { Grid } from '@chatterbug/aaron'
import PageWrapupCard from 'src/ui/PageWrapup/subcomponents/PageWrapupCard/PageWrapupCard'
import WrapupCardVocabularyGroup from 'src/pages/ActivityWrapup/subcomponents/WrapupCardVocabularyGroup/WrapupCardVocabularyGroup'

const WrapupCardVocabulary = ({ vocabularyGroups }) => {
  if (
    !vocabularyGroups?.length ||
    !vocabularyGroups.some((group) => group?.items?.length > 0)
  ) {
    return null
  }
  return (
    <PageWrapupCard>
      <Grid columns={1} gridGap={{ _: '3x', tablet: '5x' }}>
        {vocabularyGroups.map((group, index) => (
          <WrapupCardVocabularyGroup key={index} {...group} />
        ))}
      </Grid>
    </PageWrapupCard>
  )
}

WrapupCardVocabulary.propTypes = {
  vocabularyGroups: PropTypes.arrayOf(PropTypes.object),
}

export default WrapupCardVocabulary
